import { createContext } from 'react';

const AccordionContext = createContext();

export default AccordionContext;
